import * as PIXI from "pixi.js";
import * as React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { MouseTypeContainer } from "./InteractiveContainer";
import { MetadataEvent } from "../../Model/Notation/SongEvents";
import { MouseClickType } from "../Settings/Enums";
import { UIColors, UIPositioning } from "../Settings/UITheme";
import { MetadataEditBox } from "./MetadataEditBox";
import { ClickOutsideWatcher } from "../SharedReact/BasicElements";
export class MetadataTimelineEvent extends MouseTypeContainer {
    constructor(timeline) {
        super();
        this.timeline = timeline;
        this._eventEdited = this._eventEdited.bind(this);
        this._unmountEditDiv = this._unmountEditDiv.bind(this);
        this._graphics = new PIXI.Graphics();
        this._graphics.beginFill(UIColors.metadataEventColor).drawRect(0, 0, 4, UIPositioning.timelineHeaderHeight).endFill();
        this.addChild(this._graphics);
        this._editDiv = document.createElement("div");
        this._editDiv.style.position = "absolute";
        this._editDiv.style.top = UIPositioning.timelineHeaderHeight.toString() + "px";
        this._editDivMounted = false;
    }
    get active() {
        return this._active;
    }
    set active(value) {
        this._active = value;
        if (value) {
            this.alpha = 1;
        }
        else {
            this.alpha = 0.4;
        }
    }
    initialise(quarterNotePosition, active) {
        this.active = active;
        let closestEvent = this.timeline.metadata.events[this.timeline.metadata.events.binarySearch(quarterNotePosition, true)];
        if (active) {
            this.event = closestEvent;
            this.alpha = 1;
        }
        else {
            this.event = new MetadataEvent(quarterNotePosition, closestEvent.bpm, closestEvent.timeSignature);
        }
    }
    pointerOverHandler(event) {
        super.pointerOverHandler(event);
        if (!this.active) {
            this.alpha = 0.7;
        }
    }
    pointerOutHandler(event) {
        super.pointerOutHandler(event);
        if (!this.active) {
            this.alpha = 0.4;
        }
    }
    pointerUpClickHandler(event) {
        if (this._mouseClickType == MouseClickType.LeftClick) {
            if (!this.active) {
                this.active = true;
                this.event = this.timeline.metadata.addMetadataEvent(this.event.startPosition, this.event.bpm, this.event.timeSignature);
            }
            this._editDiv.style.left = (this.getGlobalPosition().x + 2).toString() + "px";
            this._mountEditDiv();
        }
        else if (this.active && this._mouseClickType == MouseClickType.RightClick && this.event.startPosition != 0) {
            this.active = false;
            this.timeline.metadata.removeMetadataEvent(this.event.startPosition);
            this._unmountEditDiv();
            let oldStartPosition = this.event.startPosition;
            let closestEvent = this.timeline.metadata.events[this.timeline.metadata.events.binarySearch(this.event.startPosition, true)];
            this.event = new MetadataEvent(this.event.startPosition, closestEvent.bpm, closestEvent.timeSignature);
            this.timeline.regenerateAroundPosition(this.timeline.metadata.positionQuarterNoteToBars(oldStartPosition));
        }
    }
    setVisible(value) {
        this.visible = value;
        if (!value) {
            this._unmountEditDiv();
        }
    }
    destroy() {
        this._unmountEditDiv();
        this._editDiv = null;
        super.destroy();
    }
    _eventEdited(timeSigNumerator, timeSigDenominator, bpm) {
        this.event = this.timeline.metadata.addMetadataEvent(this.event.startPosition, bpm, [timeSigNumerator, timeSigDenominator]);
        this._unmountEditDiv();
        this.timeline.regenerateAroundPosition(this.timeline.metadata.positionQuarterNoteToBars(this.event.startPosition));
    }
    _mountEditDiv() {
        if (!this._editDivMounted) {
            document.getElementById("applicationContainer").appendChild(this._editDiv);
            this._editDivMounted = true;
            render(React.createElement(ClickOutsideWatcher, { callback: this._unmountEditDiv },
                React.createElement(MetadataEditBox, { numerator: this.event.timeSignature[0], denominator: this.event.timeSignature[1], bpm: this.event.bpm, onSubmit: this._eventEdited })), this._editDiv);
        }
    }
    _unmountEditDiv() {
        if (this._editDivMounted) {
            unmountComponentAtNode(this._editDiv);
            document.getElementById("applicationContainer").removeChild(this._editDiv);
            this._editDivMounted = false;
        }
    }
}
//# sourceMappingURL=MetadataTimelineEvent.js.map